import React, { useContext, useEffect, useRef, useState } from 'react'
import Card from '../../../../Base/Components/Card/Card'
import CalendarWeek from '../../../../Base/Components/Form/CalendarWeek'
import { Button } from 'primereact/button';
import { getRequisasDetallePendienteAutorizar, putPermiso4 } from '../../../../API/Compras/Requisas/PurchareDetailsRequests';
import AgGrid from '../../../../Base/Components/Tables/AgGrid/AgGrid';
import { AuthContext } from '../../../../Base/Context/AuthContext/AuthContext';
import { getPermisoCostosUser } from '../../../../API/IT/Usuarios/AccesosUserRequets';
import AgenteComprasDropDown from '../Detalles/AgentesComprasDropDown';
import DialogPassword from '../../../../Base/Components/Dialog/DialogPassword/DialogPassword';
import { setTitlePage } from '../../../../Base/Services/Config/ConfigService';
import { authByUserOrRol, AccesoUser } from '../../../../API/IT/Accesos/AccesosRequests';
import { getDateTimeStringSQL } from '../../../../Base/Services/Moment/Luxon';
import { Toast } from 'primereact/toast';
import { toastShow } from '../../../../Base/Services/ToastService';
import RequisicionComprasModalCURD from '../CrudRequisa/RequisaComprasModalCrud';
import { Dialog } from 'primereact/dialog';

const LiberarRequisasScreen = () => {

    const { userAuth } = useContext(AuthContext);

    const toast = useRef(null);


    const [dates, setdates] = useState([new Date(), new Date()]);
    const [loading, setLoading] = useState(false);
    const [accesoColumnas, setAccesoColumnas] = useState(false);
    const [selected, setSelected] = useState([]);
    const [requisaEdit, setRequisaEdit] = useState(null);
    const [showDialog, setShowDialog] = useState(false);
    const [data, setData] = useState([]);
    const [showModalPermiso, setShowModalPermiso] = useState(false);
    const [password, setPassword] = useState('');

    const obtenerAccesoColumnas = async () => {
        const tempo = await getPermisoCostosUser((userAuth.idUser));
        if (tempo.length > 0) {
            setAccesoColumnas(tempo);
        }
    }

    const getInfo = async () => {
        setLoading(true);
        obtenerAccesoColumnas();
        const t = await getRequisasDetallePendienteAutorizar();
        setData(t);
        setLoading(false);
    }

    const authRol = async () => {
        const result = await authByUserOrRol({
            form: 'Acceso Maestro',
            Rol: userAuth.Rol,
            User1: userAuth.Usuario,
        })
        verificarAcceso(result);
    }

    const authPermiso = async () => {

        const result = await AccesoUser({
            Usuario: userAuth.Usuario,
            Password: password
        });
        verificarAcceso(result);
    }

    const verificarAcceso = (result) => {
        console.log(result);
        if (result[0].Acceso >= 1) {
            selected.forEach(async (item) => {
                changePermiso(item);
            });
        }else{
            toastShow(toast, 'warn', 'Advertencia', 'Credenciales no validas.');
        }
    }

    const changePermiso = async (rowEdit) => {
        
        let tempo = data;
        const index = tempo.findIndex(detail => detail.IdPurcharesRequestDetail === rowEdit.IdPurcharesRequestDetail);
        tempo[index].Permiso4 = !rowEdit.Permiso4;
        tempo[index].UsuarioPermiso4 = rowEdit.Permiso4 ? userAuth.Usuario : null;
        tempo[index].FechaPermiso4 = rowEdit.Permiso4 === true ? getDateTimeStringSQL((new Date())) : null;
        tempo[index] = changeEstado(tempo[index]);
        console.log(tempo[index]);
        const t = await putPermiso4(tempo[index].IdPurcharesRequestDetail, tempo[index].Permiso4, tempo[index].FechaPermiso4, tempo[index].UsuarioPermiso4, tempo[index].IdEstado);
        onHide();
        toastShow(toast, 'success', 'Exito', 'Permiso actualizado');
    }

    const changeEstado = (row) => {
        if (row.Permiso4) {
            // Mantenimiento
            // Planta Tratamiento
            // Mantenimiento Administracion
            // Planta Tratamiento Administrativo
          const rolMantenimiento = [1019, 1045, 1022, 1050];
        //   Mantenimiento mecanico y electrico
        //   Mantenimiento Soldadores
        //   Mantenimiento Generadores
        //   Mantenimiento Calderas
        //   Mantenimiento Planta de Tratamiento
        //   Bodega Mantenimiento
        //   Mantenimiento Electrico
        //   Mantenimiento Tecnico AC
        //   Mantenimiento Automotriz
        //   Mantenimiento
          const AreasMantenimiento = [6,7,9,10,11,45,47,48,50,67];
    
          if(AreasMantenimiento.includes(row.IdArea) || rolMantenimiento.includes(row.IdRol)){
            if([5,7].includes(row.IdComponentCategory)){
              row.EstadoPD = 'Solicitado';
              row.IdEstado = 3326;
            }else{
              row.EstadoPD = 'Revisión Bodega';
              row.IdEstado = 3600;
            }
    
          }else{
            if (row.RequestType === 'Regalia') {
              row.EstadoPD = 'Cotizado';
              row.IdEstado = 3334;
            } else {
              row.EstadoPD = 'Solicitado';
              row.IdEstado = 3326;
            }
          }
    
    
        } else {
          row.EstadoPD = 'Pendiente Revisión';
          row.IdEstado = 3518;
        }
    
        return row;
      }

    const columns = [
        {
            field: 'Date',
            header: 'Fecha',
            className: "medium",
            Format: 'DateTime'
        },
        {
            field: 'EstadoPD',
            header: 'Estado',
            className: "medium",
            body: (rowData) => ({ ID: rowData.IdEstado, Estado: rowData.EstadoPD }),
            Format: 'Estado'
        },
        {
            field: 'PurchaseRequest',
            header: 'No. Requisa',
            className: "medium",
            Format: 'Modal',
            Sumary: 'count'
        },

        {
            field: 'CodigoProducto',
            header: 'Codigo Producto',
            className: "large text-alingth-right",
        },
        {
            field: 'NombreProducto',
            header: 'Producto',
            className: "large",
        },
        {
            field: 'Description',
            header: 'Descripcion',
            className: "Xlarge",
        },
        {
            field: 'Inventario',
            className: "small",
            header: 'Inventario',
            Format: 'Currency'
        },
        {
            field: 'Quantity',
            className: "small",
            header: 'Cantidad',
            Format: 'Currency'
        },
        {
            field: 'Area',
            header: 'Area',
            className: "medium",
        },
        {
            field: 'NombreCategoria',
            header: 'Categoria',
            className: "medium ",
        },
        {
            field: 'UnitName',
            header: 'Unidad',
            className: "Xsmall",
        },
        {
            field: 'Comment',
            header: 'Comentario',
            className: "Xlarge",
        },
        {
            field: 'ASolicita',
            header: 'Solicita A',
            className: "large",
        },
        {
            field: 'Permiso4',
            header: 'Autorizado',
            className: "Xsmall",
            frozen: "frozen",
            Format: 'Checkbox',
            alignFrozen: "right",
            onChange: (e, rowData) => {
                setShowModalPermiso(true);
                if (selected.length === 0) {
                    setSelected([rowData.data]);
                    setRequisaEdit(rowData);
                }
            }
        },
    ];

    const table = {
        Columns: columns,
        Data: data,
        loading: loading,
        selected: selected,
        setSelected: setSelected,
        showModal: e => showModal(e),
    }

    const showModal = (purchaseRequest) => {
        setRequisaEdit(purchaseRequest);
        setShowDialog(true);
    }

    const onHide = () => {
        setShowDialog(false);
        setShowModalPermiso(false);
        setRequisaEdit(null);
        setSelected([]);
        setPassword('');
    }


    useEffect(() => {
        getInfo();
        setTitlePage('Liberar Requisas');
    }, [])


    return (
        <div>
            <Toast ref={toast} />
            <Card
                titulo={<div className='botones'>
                    <h2>Liberar Requisas</h2>
                    {/* <CalendarWeek
                        date={dates}
                        setDate={setdates}
                        loading={loading}
                        selectionMode='range'
                    /> */}
                    <Button icon='pi pi-search' tooltip='Buscar' onClick={getInfo} />
                </div>}

                contenido={<div className='pt-4' style={{ height: '90vh' }}>
                    <AgGrid table={table} />
                </div>}
            />
            <DialogPassword
                display={showModalPermiso}
                selected={selected}
                loading={loading}
                authByUserOrRol={authRol}
                authPermiso={authPermiso}
                onHide={onHide}
                password={password}
                setPassword={setPassword}
                showInput={true}
            />
            <Dialog visible={showDialog} onHide={onHide} maximizable closeOnEscape={false} maximized >
                <RequisicionComprasModalCURD idRequisa={requisaEdit} showDialog={showDialog} />
            </Dialog>
        </div>
    )
}

export default LiberarRequisasScreen